import { useEffect, useRef, useState } from 'react';
import RoleEdit from './RoleEdit';
import WebUniversal, { WebUniversalProps } from '../../system/WebUniversal';
import { Space, Button, Tooltip } from 'antd';
import RoleOrUserLicense from './RoleOrUserLicense';
import RoleOrUserLicenseEx from './RoleOrUserLicenseEx'
import fetchApi from '../../../utilsTsx/components/system/fetchApi';
import CustomSelect from '../../../utilsTsx/components/hooks/CustomSelect';
import { columnsheadId } from '../../../utilsTsx/components/system/columnshead';
import NewUserRoleConfig from './NewUserRoleConfig';

const Role = (props: any) => {
    const apiId = 'role';
    const ref = useRef<any>(undefined);
    const [modalRoleOrUserLicense, setModalRoleOrUserLicense] = useState(false);
    const [modalNewUserRoleConfig, setModalNewUserRoleConfig] = useState(false);
    const [roleInfo, setRoleInfo] = useState<any>();
    const [modalRoleLicenseEx, setModalRoleLicenseEx] = useState(false);
    const [defaultService, setDefaultService] = useState<string>('');
    const [fetchData, setFetchData] = useState<any>();
    const [brandData, setBrandData] = useState<any>();
    const [roleGroupData, setRoleGroupData] = useState<any>();
    const [sendPageData, setSendPageData] = useState<any>()

    useEffect(() => {
        let urlService;
        if (ref.current) {
            urlService = ref.current.defaultService
            setDefaultService(urlService);
            setFetchData(() => ref.current.fetchData);
        }
        fetchApi.GET(urlService, {
            query: {
                apiId: 'brand',
                apiExtend: 'showList'
            }
        }).then(res => {
            if (res.success) {
                setBrandData([{ id: 'ALLITEM', brandName: '所有' }, ...res.data]);
            }
        })
        fetchApi.GET(urlService, {
            query: {
                apiId: 'roleGroup',
                apiExtend: 'showList'
            }
        }).then(res => {
            if (res.success) {
                setRoleGroupData([{ id: 'ALLITEM', roleGroupName: '所有' }, ...res.data]);
            }
        })
    }, []);

    const handleLicense = (record: any) => {
        setRoleInfo({
            roleOrUserId: record.id,
            itemName: record.roleName
        });
        setModalRoleOrUserLicense(true);
    }
    /**
     * 复制角色
     * @param roleId 
     */
    const handleCopyRole = (options: {
        roleId: string;
        roleName: string;
    }) => {
        const { roleId, roleName } = options;
        fetchApi.POST(defaultService, {
            body: {
                apiId: 'role',
                apiExtend: 'copy',
                apiVariable: roleId,
                apiData: {
                    roleName
                }
            }
        }).then(res => {
            if (res.success) {
                fetchData?.();
            }
        })
    };

    /** 角色权限（特殊）扩展 */
    const handleRoleLicenseExpand = (record: any) => {
        setRoleInfo({
            roleOrUserId: record.id,
            itemName: record.roleName
        });
        setModalRoleLicenseEx(true)
    };
    /** 子组件回调函数，关闭角色权根（特殊）扩展 */
    const onCloseModalRoleLicenseEx = () => {
        setModalRoleLicenseEx(false)
    };

    /** 表头内容 */
    const columnsHead = [
        {
            title: '角色名称',
            dataIndex: 'roleName',
            sorter: true,
        },
        {
            title: '角色组',
            dataIndex: 'roleGroup',
            sorter: true,
            render: (val: any) => (val?.roleGroupName)
        },
        {
            title: '品牌',
            dataIndex: 'brand',
            render: (val: any) => (val?.brandName)
        },
        {
            title: '权限',
            dataIndex: 'operation',
            key: 'operation',
            render: (val: any, record: any) =>
                <Space size="small">
                    <Button size={"small"} type="primary" onClick={() => handleLicense(record)}>权限</Button>
                </Space>
        },
        {
            title: '特殊',
            dataIndex: 'roleLicenseExpand',
            key: 'roleLicenseExpand',
            render: (val: any, record: any) =>
                <Space size="small">
                    <Tooltip placement="topLeft" title={'权限（特殊）扩展'}>
                        <Button size={"small"} type="primary" onClick={() => handleRoleLicenseExpand(record)}>特殊</Button>
                    </Tooltip>
                </Space>
        },
        {
            title: '复制',
            dataIndex: 'id',
            key: 'id',
            render: (val: any, record: any) =>
                <Tooltip placement="topLeft" title={'复制【' + record.roleName + '】角色'}> <Space size="small">
                    <Button size={"small"} type="primary" onClick={() => handleCopyRole({
                        roleId: val,
                        roleName: `${record.roleName} 副本`
                    })}>复制</Button>
                </Space></Tooltip>
        },
        {
            title: '排序',
            dataIndex: 'sort',
            sorter: true
        },
    ];

    /** 表头 */
    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WebUniversalProps = {
        ...props,
        titleName: '角色',
        apiId,
        columns,
        editOptions: {
            Editor: RoleEdit
        }
    };

    return (
        <> <Space>
            <CustomSelect
                apiId={apiId}
                sendKeyId='roleGroupId'
                getListData={roleGroupData}
                sendPageData={sendPageData}
                setSendPageData={setSendPageData}
                fetchData={fetchData}
                itemName="roleGroupName"
            />
            <CustomSelect
                apiId={apiId}
                sendKeyId='brandId'
                getListData={brandData}
                sendPageData={sendPageData}
                setSendPageData={setSendPageData}
                fetchData={fetchData}
                itemName="brandName"
            />
            <Tooltip placement="topLeft" title={'当新增会员时配置默认角色'}>
                <Button onClick={() => setModalNewUserRoleConfig(true)}>会员角色配置</Button></Tooltip>
        </Space>
            <> </>
            <WebUniversal {...extendProps} ref={ref} />
            {modalRoleOrUserLicense ? (<RoleOrUserLicense
                closeModal={() => setModalRoleOrUserLicense(false)}
                info={roleInfo}
                useType={'roleLicense'} />)
                : null}
            {modalRoleLicenseEx ? (<RoleOrUserLicenseEx
                closeModal={onCloseModalRoleLicenseEx}
                useType={'roleLicense'}
                info={roleInfo}
            ></RoleOrUserLicenseEx>) : null}
            {modalNewUserRoleConfig ? (<NewUserRoleConfig
                closeModal={() => setModalNewUserRoleConfig(false)}
            ></NewUserRoleConfig>) : null}
        </>
    )
}

export default Role;